import type { TenantId, TenantConfig } from './types';
import { defaultTenant } from './tenants/default';

const tenantMap: Record<TenantId, TenantConfig> = {
  default: defaultTenant,
};

const tenantId = (process.env.REACT_APP_TENANT || 'default') as TenantId;

export const tenantConfig: TenantConfig = tenantMap[tenantId] || tenantMap.default;

export function applyTenantTheme(): void {
  const { branding, theme } = tenantConfig;
  const root = document.documentElement;

  // Apply theme CSS custom properties
  root.style.setProperty('--tenant-primary', theme.primary);
  root.style.setProperty('--tenant-primary-hover', theme.primaryHover);
  root.style.setProperty('--tenant-primary-light', theme.primaryLight);
  root.style.setProperty('--tenant-secondary', theme.secondary);
  root.style.setProperty('--tenant-accent', theme.accent);
  root.style.setProperty('--tenant-sidebar-bg', theme.sidebarBg);
  root.style.setProperty('--tenant-sidebar-text', theme.sidebarText);
  root.style.setProperty('--tenant-sidebar-active-text', theme.sidebarActiveText);
  root.style.setProperty('--tenant-sidebar-active-bg', theme.sidebarActiveBg);

  // Apply branding
  document.title = branding.pageTitle;

  // Favicon
  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (favicon) {
    favicon.href = branding.favicon;
  }

  // Meta description
  const metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (metaDesc) {
    metaDesc.content = branding.metaDescription;
  }

  // Meta author
  let metaAuthor = document.querySelector<HTMLMetaElement>('meta[name="author"]');
  if (!metaAuthor) {
    metaAuthor = document.createElement('meta');
    metaAuthor.name = 'author';
    document.head.appendChild(metaAuthor);
  }
  metaAuthor.content = branding.metaAuthor;

  // Google Fonts
  if (branding.fontsUrl) {
    const existingLink = document.querySelector<HTMLLinkElement>('link[data-tenant-fonts]');
    if (!existingLink) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = branding.fontsUrl;
      link.setAttribute('data-tenant-fonts', 'true');
      document.head.appendChild(link);
    }
  }
}

export type { TenantId, TenantConfig, TenantTheme, TenantBranding } from './types';
